import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom"
import { Col, Row, Button, Divider, Progress, Spin, message, Switch } from 'antd'
import { ArrowLeftOutlined, LoadingOutlined, CheckOutlined, SettingOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom"
import { getExtractedData } from "./../../api/Scan/Scan"
import { getFileFromBucket } from "../../api/AWS/getFile"
import CameraRender from './CameraRender'
import ExtractedData from './ExtractedData';
import { getAverageColor } from './AverageColor';
import BugReport from './BugReport';
import { getBpProgression } from '../../api/BPTable/BPTableMethods';
import { createOLPN, getCurrentOLPN, getOLPNById, getOlpnCount } from "../../api/OLPN/olpn"
import OlpnModal from './OlpnModal';
import { OlpnContext } from './OlpnContext';
import Html5QrcodePlugin from "./QrPlugin.jsx"
import { averageColor, setAverageColor } from '../../api/Color/color';
import { getThreshold } from '../../api/Threshold/Threshold';
import { v4 as uuidv4 } from "uuid"
import Settings from './Settings';
import { getSettings } from '../../api/CameraSettings/cameraSettings';
import { QrImage } from './QrPluginImage';
import { cropImage, bitmapToBlob } from "./../Utils/cropImage"
import jsQR from "jsqr";
import NewWindow from "./../../assets/new-window.svg"
import "./scanning.css"
import PhotoOnly from './PhotoOnly';
import { stopCamera } from '../Utils/stopCamera';
import { getPendingTrayCount } from '../../api/trayTable/TrayTableMethods';
import { dkError } from '../../api/errors/errors';
import LowImage from './LowImage';
import * as $ from 'jquery';
import { getModelSettings, setModelSettings } from '../../api/Model/model';

function Scanning() {
  const [loading, setLoading] = useState<boolean>(false)
  const [photoLoading, setPhotoLoading] = useState<boolean>(false)
  const [aiLoading, setAiLoading] = useState<boolean>(false)
  const [data, setData] = useState<any>(undefined)
  const [validated, setValidated] = useState<boolean>(false)
  const [clearTimer, setClearTimer] = useState<boolean>(false)
  const [status, setStatus] = useState<string>("")
  const [isOk, setIsOk] = useState<boolean>(false)
  const [_, setError] = useState<string | undefined>(undefined)
  const [showImage, setShowImage] = useState<string | undefined>(undefined)
  const [renderCamera, setRenderCamera] = useState<boolean>(false)
  const [progress, setProgression] = useState<any>(undefined)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [Olpn, setOlpn] = useState<string | undefined>(undefined)
  const [isOLPN, setIsOLPN] = useState<boolean>(false)
  const [OLPNModal, setOLPNModal] = useState<boolean>(false)
  const [closeOLPN, setCloseOLPN] = useState<boolean>(false)
  const [name, setName] = useState<string | undefined>(undefined)
  const [value, setValue] = useState<string>("")
  const [deviceId, setDeviceId] = useState<number>(0);
  const [autoPhoto, setAuto] = useState<boolean>(true);
  const [autoLoading, setAutoLoading] = useState<boolean>(false)
  const [devices, setDevices] = useState<any>([]);
  const [slider, setSlider] = useState<number>(0.05)
  const [_color, setColor] = useState<number[]>([])
  const [bpComplete, setBpComplete] = useState<boolean>(false)
  const [settingsModal, setSettingsModal] = useState<boolean>(false)
  const [isPhotoOnly, setIsPhotoOnly] = useState<boolean>(false)
  const [qrImage, setCropImage] = useState<any>(undefined)
  const [qrImage2, setCropImage2] = useState<any>(undefined)
  const [qrImage3, setCropImage3] = useState<any>(undefined)
  const [qrImage4, setCropImage4] = useState<any>(undefined)
  const [qrImage5, setCropImage5] = useState<any>(undefined)
  const [qrImageValue, setQrImageValue] = useState<string | undefined>(undefined)
  const [debugScan, setDebugScan] = useState<boolean>(false)
  const [refresh, setRefresh] = useState<boolean>(false)
  const [countOLPN, setCountOLPN] = useState<number>(0)
  const [pendingTray, setPendingTray] = useState<number>(0)
  const [lowImage, setLowImage] = useState<boolean>(false)
  const [tray, setTray] = useState<boolean>(false)
  const [trayID, setTrayID] = useState<string>("")
  const [resolution, setResolution] = useState<{ width: number, height: number, resolution: string } | undefined>(undefined)
  const [modelConfig, setModelConfig] = useState<boolean>(false)
  const [uploadViaBackend, setUploadViaBackend] = useState<boolean>(false)
  let { bpId, sku, trayNumber } = useParams()
  const webcamRef = React.useRef<any>(null);
  const r: any = React.useRef(null);
  const canvasRef = React.useRef(null)
  r.current = { autoPhoto, setAuto, autoLoading, setAutoLoading, slider, _color };

  let navigate = useNavigate()

  useEffect(() => {
    getAvColor()
    getData()
    sessionStorage.removeItem("photo_only")
    return () => {
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    $(document).on('keypress', function (e) {
      if (e.key === "Enter" && !sessionStorage.getItem('image') && !sessionStorage.getItem("photo_only")) {
        capture()
      }
    });
    return () => {
      $(document).off()
    }
  }, [value, isPhotoOnly, countOLPN, refresh, isOLPN, Olpn, name, value, data, status, devices, showImage])

  useEffect(() => {
    if (progress && !progress.code) {
      if (progress.progression[0] === progress.progression[1])
        setBpComplete(true)
    }
    getCamera()
  }, [progress])

  useEffect(() => {
    setStatus("")
    setShowImage(undefined)
    setCropImage(undefined)
    setCropImage2(undefined)
    setCropImage3(undefined)
    setCropImage4(undefined)
    setCropImage5(undefined)
    setValidated(false)
  }, [isPhotoOnly])

  useEffect(() => {
    if (true) {
      setTimeout(() => { getColor() }, 1000)
    }
  }, [renderCamera])

  window.addEventListener('offline', (e) => {
    if (!data) {
      setLoading(false)
      setError("Connexion impossible")
      setStatus("")
      setShowImage(undefined)
    }
  })

  useEffect(() => {
    getData()
  }, [Olpn])

  useEffect(() => {
    if (isOLPN === false && progress && progress.progression[0] !== progress.progression[1]) {
      handleOLPN()
      message.success('Un nouvel OLPN a été crée ')
    }
  }, [isOLPN])

  useEffect(() => {
    const timer = setTimeout(() => { getColor() }, 1000)
    return () => clearTimeout(timer)
  }, [deviceId, validated])

  useEffect(() => {
    let timer: any;
    if (debugScan && webcamRef.current) {
      timer = setInterval(async () => {
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
          const img = new Image();
          img.src = imageSrc;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const dx = Math.floor(img.width * 0.6);
            const dy = Math.floor(img.height * 0.6);
            const x = Math.floor((img.width - dx) / 2);
            const y = Math.floor((img.height - dy) / 2);
            canvas.width = dx;
            canvas.height = dy;
            ctx?.drawImage(img, x, y, dx, dy, 0, 0, dx, dy);
            const imageData = ctx?.getImageData(0, 0, dx, dy);
            if (imageData) {
              const code = jsQR(imageData.data, imageData.width, imageData.height);
              if (code) {
                console.log(`[Debug Scan] Found QR: ${code.data}`);
              }
            }
          };
        }
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [debugScan]);

  const getAvColor = async () => {
    const color = await averageColor();
    const threshold = await getThreshold()
    if (color.data?.RGBA)
      setColor(color.data.RGBA)
    else message.warn('Calibrez une couleur')
    if (threshold.data?.threshold)
      setSlider(threshold.data.threshold)
  }

  const getCamera = async () => {
    const cameraSettings = await getSettings()
    if (cameraSettings) {
      const i = devices.findIndex((el: any) => el.deviceId === cameraSettings.cameraId)
      if (i > 0) setDeviceId(i)
      else setDeviceId(0)
      setRefresh(cameraSettings.refresh)
      setAuto(cameraSettings.trayDetection)
      setIsPhotoOnly(cameraSettings.photoOnly)
      setResolution(cameraSettings?.resolution ?? { width: 3840, height: 2160, resolution: '2160p' })
      setUploadViaBackend(cameraSettings?.uploadViaBackend ?? false)
    }
    const modelConfig = await getModelSettings()
    setModelConfig(modelConfig.newModel ?? false)
  }

  const handleDevices = React.useCallback(
    mediaDevices =>
      setDevices(mediaDevices.filter((elem) => {
        return elem.kind === "videoinput"
      })),
    [setDevices]
  );

  useEffect(() => {
    if (devices.length > 0) {
      getCamera()
    }
  }, [devices])

  React.useEffect(
    () => {
      navigator.mediaDevices.enumerateDevices().then(handleDevices);
    },
    [handleDevices]
  );

  const getData = async () => {
    if (bpId) {
      const res: any = await getBpProgression(bpId)
      const currentOLPN = await getCurrentOLPN(Number(bpId))
      if (currentOLPN.data?.currentOLPN && currentOLPN.data?.currentOLPN.length > 0) {
        setOlpn(currentOLPN.data.currentOLPN)
        setIsOLPN(true)
        const name = await getOLPNById(currentOLPN.data.currentOLPN)
        const count = await getOlpnCount(name.data._id)
        const pending = await getPendingTrayCount(bpId)
        setPendingTray(pending.total)
        setCountOLPN(count.total)
        if (name.data.OLPN && name.data.OLPN.length > 0) setName(name.data.OLPN)
        else setName(undefined)
      } else {
        setIsOLPN(false)
      }
      setProgression(res)
      if (res?.progression?.[0] === res?.progression?.[1]) {
        setBpComplete(true)
      }
    }
  }

  const getColor = () => {
    let video = document.getElementById("webcam")
    const timer = setInterval(() => {
      if (clearTimer) return clearInterval(timer)
      if (video) {
        const color = getAverageColor(video)
        if (color?.hexa === "#00000000") return clearInterval(timer)
        checkColor(color)
      }
    }, 1000)
    return () => clearInterval(timer)
  }

  const checkColor = (color) => {
    if (color) {
      var diffR: number, diffG: number, diffB: number;
      diffR = (r.current._color[0] - color.value[0]);
      diffG = (r.current._color[1] - color.value[1]);
      diffB = (r.current._color[2] - color.value[2]);
      let res = (diffR * diffR + diffG * diffG + diffB * diffB);
      const percent = res / ((255) ^ 2 + (255) ^ 2 + (255) ^ 2)
      if (percent < r.current.slider) {
        setStatus("")
        setIsOk(true)
      } else if (percent > r.current.slider) {
        setStatus("ready")
        setIsOk(false)
      }
      return res
    }
  }


  const handleBackButton = () => {
    setClearTimer(true)
    navigate(-1)
  }

  const resetState = () => {
    setPhotoLoading(true)
    setLoading(true)
    setStatus("loading")
    setData(undefined)
    setError(undefined)
    setValidated(false)
    setTrayID("")
    setCropImage(undefined)
    setCropImage2(undefined)
    setCropImage3(undefined)
    setCropImage4(undefined)
    setCropImage5(undefined)
  }

  const capture = async () => {
    if (!isOLPN && localStorage.getItem("isTest") !== "true") return message.error('Aucun OLPN n\'a été séléctioné');

    // Test mode: bypass camera entirely and call API with dummy data
    if (localStorage.getItem("isTest") === "true") {
      sessionStorage.setItem("scan_start", new Date().toISOString())
      resetState()
      sessionStorage.setItem("take_photo", new Date().toISOString())
      setPhotoLoading(false)
      setAiLoading(true)
      setAutoLoading(false)
      if (bpId) {
        const trayId = uuidv4()
        const dummyBlob = new Blob(["test"], { type: "image/jpeg" })
        // Force isPhotoOnly to false in test mode to ensure API call is made
        let res: any = await getExtractedData(dummyBlob, bpId, trayId, false, "TEST_QR_CODE", uploadViaBackend);
        console.log("Test mode result:", res)
        sessionStorage.setItem("s3Path", bpId + '/' + trayId);
        sessionStorage.setItem("AI", new Date().toISOString())
        if (!res.data || (res.data && res?.data?.data?.length === 0)) {
          setShowImage(undefined)
          setStatus("error")
          setAiLoading(false)
          return setLoading(false)
        }
        if (res.data?.status !== 200) {
          setStatus("error")
          setError(res.data.data.description)
        } else
          setData(res.data)
        setLoading(false)
        setAiLoading(false)
      }
      return
    }

    if (webcamRef) {
      sessionStorage.setItem("scan_start", new Date().toISOString())
      resetState()
      let mediaStream = await navigator?.mediaDevices.getUserMedia({ video: { deviceId: { exact: devices[deviceId]?.deviceId }, width: 4096, height: 2160 } })
      if (!mediaStream) return
      let media = mediaStream.getVideoTracks()
      let id = media.find(elem => (elem.getSettings().deviceId === devices[deviceId]?.deviceId))
      if (!id) {
        setLoading(false);
        setStatus("");
        setAutoLoading(false)
        return message.error("Un probleme est survenue avec la camera selectionnée");
      }
      const imageSrc = webcamRef.current.getScreenshot();
      stopCamera("#webcam")
      setShowImage(imageSrc)
      const imgCapture = await new ImageCapture(id)
      if (imgCapture) {
        const bitmap = await imgCapture.grabFrame()
        const photo = await bitmapToBlob(bitmap)
        if (photo && photo.size < 700000 && window.location.host !== 'localhost:3000') {
          setStatus("")
          setShowImage(undefined)
          setLoading(false)
          setLowImage(true)
          if (!isPhotoOnly) return
        }
        sessionStorage.setItem("take_photo", new Date().toISOString())
        setPhotoLoading(false)
        setAiLoading(true)
        setShowImage(imageSrc)
        setAutoLoading(false)
        if (bpId && photo) {
          await cropImage(photo, 700, 400, "TOPLEFT", 'qr-canvas-1', setCropImage)
          await cropImage(photo, 700, 400, "TOPRIGHT", 'qr-canvas-2', setCropImage2)
          await cropImage(photo, 700, 400, "BOTTOMLEFT", 'qr-canvas-3', setCropImage3)
          await cropImage(photo, 700, 400, "BOTTOMRIGHT", 'qr-canvas-4', setCropImage4)
          await cropImage(photo, 700, 400, "CENTER", 'qr-canvas-5', setCropImage5)
          const trayId = uuidv4()
          let res: any = await getExtractedData(photo, bpId, trayId, isPhotoOnly, qrImageValue, uploadViaBackend);
          console.log(res)
          sessionStorage.setItem("s3Path", bpId + '/' + trayId);
          sessionStorage.setItem("AI", new Date().toISOString())
          const imageData = await getFileFromBucket(bpId + "/" + trayId + '.jpeg')
          if (!res.data || (res.data && res?.data?.data?.length === 0)) {
            if (isPhotoOnly) {
              sessionStorage.setItem("photo_only", "true")
              setStatus("wait")
              setAiLoading(false)
              return setLoading(false)
            } else {
              await dkError(bpId + "/" + trayId, bpId, "empty result", {})
              setShowImage(undefined)
              setStatus("error")
              setAiLoading(false)
              return setLoading(false)
            }
          }
          setShowImage(imageData)
          if (res.data?.status !== 200) {
            setStatus("error")
            setError(res.data.data.description)
          } else
            setData(res.data)
          // if (refresh)
          //   window.location.reload()
          setLoading(false)
          setAiLoading(false)
        }
      }
    }
  }

  const handleOLPN = async () => {
    if (bpId) {
      if (isOLPN) return message.error("Un oLPN est déjà en cours. Si vous souhaitez en crée un nouveau, veuillez terminer celui en cours.")
      await createOLPN(Number(bpId))
      await getData()
    }
  }

  const handleCloseOLPN = async () => {
    setCloseOLPN(true)
  }

  const ScanningTitle = () => (
    <>
      {trayNumber ?
        "Reprise du plateau " + trayNumber
        :
        <>
          {closeOLPN ?
            "Placer l’étiquette du colis sous la caméra"
            :
            <>
              {data ?
                <></>
                :
                "Placer le plateau dans les marqueurs"
              }
            </>
          }
        </>
      }
    </>
  )

  const StatusText = (props: { status: string }) => {
    if (props.status === "wait")
      return <><span>Valider le plateau</span></>
    if (props.status === "complete")
      return <><CheckOutlined style={{ color: "#32de84", paddingRight: '1rem' }} /><span>Scan terminé</span></>
    if (props.status === "ready")
      return <><div className='green-dot' /><span>Scan pret</span></>
    if (props.status === 'error')
      return <><div className='red-dot' /><span>Erreur</span></>
    if (props.status === 'loading')
      return (
        <>
          <Spin indicator={<LoadingOutlined style={{ fontSize: '2rem', marginRight: '1rem' }} />} />
          <span>Scan en cours...</span>
        </>
      )
    else
      return <></>
  }

  const handleProblem = () => {
    setOpenModal(true)
  }

  const qrResult = (decodedText, _decodedResult) => {
    if (tray) {
      setTray(false)
      setTrayID(decodedText)
      sessionStorage.setItem("decodedText", decodedText)
    } else {
      setOLPNModal(true)
      setValue(decodedText)
    }
  }

  const qrIdResult = (decodedText, _decodedResult) => {
    setQrImageValue(decodedText ?? null)
  }

  const calibrate = () => {
    let video = document.getElementById("webcam")
    const color = getAverageColor(video)
    if (color?.value) {
      setColor(color?.value)
      setAverageColor(color?.value);
    }
  }

  const handleModelSetting = async (e: boolean) => {
    setModelConfig(e)
    await setModelSettings(e)
  }

  return (
    <OlpnContext.Provider value={{ Olpn, setOlpn }}>
      <div className="scanning-main">
        <Spin indicator={<LoadingOutlined style={{ fontSize: "10rem", color: "black" }} />} spinning={loading} tip={
          <div style={{ fontSize: '2rem', marginTop: "10rem", color: "black" }}>
            {photoLoading && "Prise de photo en cours, ne pas bouger le plateau"}
            {aiLoading && "L'IA analyse le plateau"}
          </div>
        }>
          <canvas id="qr-canvas-1" style={{ display: "none", zIndex: 0 }} />
          <canvas id="qr-canvas-2" style={{ display: "none", zIndex: 0 }} />
          <canvas id="qr-canvas-3" style={{ display: "none", zIndex: 0 }} />
          <canvas id="qr-canvas-4" style={{ display: "none", zIndex: 0 }} />
          <canvas id="qr-canvas-5" style={{ display: "none", zIndex: 0 }} />
          <LowImage lowImage={lowImage} setLowImage={setLowImage} />
          <BugReport openModal={openModal} setOpenModal={setOpenModal} />
          <OlpnModal setOLPNModal={setOLPNModal} OLPNModal={OLPNModal} currentOLPN={Olpn} bpId={bpId} setValue={setValue} value={value} setCloseOLPN={setCloseOLPN} progress={progress} handleOLPN={handleOLPN} />
          <Settings setSettingsModal={setSettingsModal} settingsModal={settingsModal} setAuto={setAuto} auto={autoPhoto}
            setSlider={setSlider} slider={slider} calibrate={calibrate} _color={_color} setDeviceId={setDeviceId}
            deviceId={deviceId} devices={devices} setIsPhotoOnly={setIsPhotoOnly} isPhotoOnly={isPhotoOnly}
            setRefresh={setRefresh} refresh={refresh} resolution={resolution} setResolution={setResolution}
            setDebugScan={setDebugScan} debugScan={debugScan}
            setUploadViaBackend={setUploadViaBackend} uploadViaBackend={uploadViaBackend}
          />
          <Row style={{ height: "100%" }} className='scanning-row'>
            <Col lg={18} md={24} style={{ height: '90%', width: "100%" }}>
              <Row>
                <Col xs={2} style={{ paddingTop: "1rem" }}>
                  <Button className='scanning-back-button' onClick={() => handleBackButton()}>
                    <ArrowLeftOutlined className='back-icon-style' />
                  </Button>
                </Col>
                <Col xs={4} style={{ paddingTop: "1rem", textAlign: 'center' }}>
                </Col>
                <Col xs={14}>
                  <h2 className='scanning-title'>
                    <ScanningTitle />
                  </h2>
                </Col>
              </Row>
              {
                closeOLPN || tray ?
                  <Col xs={24} style={{ position: "relative", height: "95%", display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                    <div className='qr-video' >
                      <Html5QrcodePlugin
                        device={devices[deviceId]}
                        fps={10}
                        qrbox={400}
                        disableFlip={false}
                        qrCodeSuccessCallback={qrResult}
                        closeOLPN={closeOLPN}
                        tray={tray}
                      />
                    </div>
                  </Col>
                  :
                  showImage ?
                    <div className='image-container'>
                      <img id='image_screenshot' className='image-screenshot' src={showImage} alt={"image_screenshot"} />
                      {isPhotoOnly && qrImage && qrImage2 && qrImage3 && qrImage4 && localStorage.getItem("isTest") !== "true" ? (
                        <>
                          <QrImage image={qrImage} callback={qrIdResult} id={"image_qr_1"} />
                          <QrImage image={qrImage2} callback={qrIdResult} id={"image_qr_2"} />
                          <QrImage image={qrImage3} callback={qrIdResult} id={"image_qr_3"} />
                          <QrImage image={qrImage4} callback={qrIdResult} id={"image_qr_4"} />
                          <QrImage image={qrImage5} callback={qrIdResult} id={"image_qr_5"} />
                        </>
                      )
                        :
                        <>
                          {qrImage && qrImage2 && qrImage3 && qrImage4 && localStorage.getItem("isTest") !== "true" &&
                            <>
                              <QrImage image={qrImage} callback={qrIdResult} id={"image_qr_1"} />
                              <QrImage image={qrImage2} callback={qrIdResult} id={"image_qr_2"} />
                              <QrImage image={qrImage3} callback={qrIdResult} id={"image_qr_3"} />
                              <QrImage image={qrImage4} callback={qrIdResult} id={"image_qr_4"} />
                              <QrImage image={qrImage5} callback={qrIdResult} id={"image_qr_5"} />
                            </>
                          }
                          <canvas ref={canvasRef} className="canvas-box" id='canvas-box' />
                        </>
                      }
                    </div>
                    :
                    <CameraRender webcamRef={webcamRef} isOk={isOk} setRenderCamera={setRenderCamera} closeOLPN={closeOLPN}
                      device={devices[deviceId]} devices={devices} resolution={resolution}
                    />
              }
              <Row>
                <Col xs={4}>
                  <Button className='button-nofocus' size='large' onClick={() => { setSettingsModal(true) }}>
                    <SettingOutlined />
                    Avancé
                  </Button>
                </Col>
                <Col xs={20} pull={2}>
                  <div className='status-message'><StatusText status={status} /></div>
                </Col>
              </Row>
            </Col>
            <Col lg={6} md={24} className='scanning-right-panel'>
              <Row className='scanning-row-right-panel'>
                <Col xs={24}>
                  <h2>{`BP ${bpId}`}
                    {pendingTray > 0 &&
                      <span className='pending-tray' onClick={() => { window.open(`http://${window.location.host}/edit/${bpId}/${sku}/pending`, "_blank")?.focus() }}>{`${pendingTray} ${pendingTray > 1 ? "plateaux" : "plateau"} en attente`}
                        <img src={NewWindow} className="new-window-logo" alt="" />
                      </span>
                    }
                  </h2>
                  <div className='sku-title'>SKU {sku}</div>
                </Col>
                <Progress style={{ width: "100%" }} className='progress-bar' percent={progress && progress?.progression ? progress?.progression[0] / progress?.progression[1] * 100 : 0} size="small" showInfo={false} />
                <div style={{ width: "100%" }} className='progression-number'>BP:
                  <span className='progression-bold'> {progress && progress?.progression ? progress?.progression[0] : 0} </span> /  {progress?.progression ? progress.progression[1] : 0}
                  <span>{` (Quantité restante`}</span>
                  <span className='progression-bold'>{progress?.progression ? ` ${progress?.progression[1] - progress.progression[0]}` : 0}</span>
                  <span>{`)`}</span>
                </div>
                <Progress className='progress-bar olpn-progress' strokeColor={"orange"} percent={(countOLPN / 270) * 100} size="small" showInfo={false} />
                <div>{`Colis en cours: `}
                  <span className='progression-bold'>{` ${countOLPN} `}</span>
                  {`${countOLPN > 1 ? 'bracelets' : 'bracelet'}`}
                </div>
                <Divider />
                {
                  !isOLPN ?
                    <Col xs={24} className='col-olpn'>
                      <Button className='button-olpn' onClick={() => handleOLPN()}>Nouveau colis</Button>
                    </Col>
                    :
                    <Col xs={24} className='col-olpn'>
                      {name ?
                        <h4 className='olpn-title'>Colis {name}</h4>
                        :
                        <>
                          <h4 className='olpn-title'>Un colis est en cours</h4>
                          {
                            closeOLPN ?
                              <Button className='button-olpn' onClick={() => setOLPNModal(true)}>Saisir n°oLPN</Button>
                              :
                              <Button className='button-olpn' onClick={() => handleCloseOLPN()}>Fermer colis</Button>
                          }
                        </>
                      }
                    </Col>
                }
              </Row>
              <Divider />
              <Row className='scan-button-row scanning-row-right-panel'>
                {isPhotoOnly && qrImage && !closeOLPN &&
                  <PhotoOnly qrText={qrImageValue} setCropImage={setCropImage} OLPN={Olpn} setShowImage={setShowImage} setValidated={setValidated} setProgression={setProgression} progress={progress} refresh={refresh} tray={tray} setTray={setTray} trayID={trayID} setTrayID={setTrayID} />
                }
                {data && !bpComplete &&
                  <>
                    {closeOLPN || tray ?
                      <Col xs={24}>
                        <div style={{ textAlign: 'center' }}>
                          <Button id="scanning-button" onClick={() => {
                            setCloseOLPN(false)
                            setTray(false)
                          }} className='scan-button' >
                            Annuler
                          </Button>
                        </div>
                      </Col>
                      :
                      <ExtractedData data={data} setData={setData} setValidated={setValidated} validated={validated} setShowImage={setShowImage}
                        setStatus={setStatus} setProgression={setProgression} progress={progress} OLPN={Olpn} canvasRef={canvasRef} isRefresh={refresh} qrData={qrImageValue}
                        setCountOLPN={setCountOLPN} setPendingTray={setPendingTray} tray={tray} setTray={setTray} trayID={trayID} setTrayID={setTrayID} />
                    }
                  </>
                }
                {bpComplete ?
                  <>
                    {closeOLPN &&
                      <Col xs={24}>
                        <div style={{ textAlign: 'center' }}>
                          <Button id="scanning-button" onClick={() => setCloseOLPN(false)} className='scan-button' >
                            Annuler
                          </Button>
                        </div>
                      </Col>
                    }
                    <h1 style={{ textAlign: 'center' }}>
                      Ce BP est completé
                    </h1>
                  </>
                  :
                  <>
                    {(closeOLPN || tray) && !data &&
                      <Col xs={24}>
                        <div style={{ textAlign: 'center' }}>
                          <Button id="scanning-button" onClick={() => {
                            setCloseOLPN(false)
                            setTray(false)
                          }} className='scan-button' >
                            Annuler
                          </Button>
                        </div>
                      </Col>
                    }
                    {!data && !sessionStorage.getItem("photo_only") && !closeOLPN &&
                      <Button onClick={capture} className='scan-button'
                        id="scan-button"
                        disabled={localStorage.getItem("isTest") === "true" ? false : (!autoPhoto ? false : isOk)}
                        style={localStorage.getItem("isTest") === "true" ? { backgroundColor: '#10b981', color: "white" } : (!autoPhoto ? { backgroundColor: '#10b981', color: "white" } : !isOk ? { backgroundColor: '#10b981', color: "white" } : {})} >
                        Scanner
                      </Button>
                    }
                  </>
                }
              </Row>
              <Row>
                <div className='problem-container'>
                  <span className='problem' onClick={handleProblem}>
                    <ExclamationCircleOutlined className='bug-icon' />
                    Signalez un probleme
                  </span>
                </div>
              </Row>
            </Col>
          </Row>
        </Spin>
      </div >
    </OlpnContext.Provider >
  )
}

export default Scanning